import { laborApi, dailySaleApi } from "../client";
import { LABOUR_CUSTOMIZE, PAYROLL_REPORT } from "../endpoints";
import { getMenuIdFromUrl } from "../../APIs/auth";

export const getCorporationDetails = async (corpId) => {
  const payload = typeof corpId === "object" ? corpId : { corpId };
  const res = await laborApi.post(LABOUR_CUSTOMIZE.CORPORATION_DETAILS, payload);
  return res.data;
};

export const getManagementGroupsList = async () => {
  const res = await laborApi.get(LABOUR_CUSTOMIZE.GET_MANAGEMENT_GROUPS_LIST);
  return res.data;
};

/**
 * Calls GET /v1/DailySale/GetCorpAndPCListByMgntGrpWithPmsBrandSerTypes?MgntGrpId=${managementGroupId}
 * and formats the result with unique row IDs and property aliases.
 */
export const getCorpAndPCListByMgntGrp = async (mgntGrpId = 'PropertyType') => {
  try {
    const formattedGrpId =
      !mgntGrpId || String(mgntGrpId).toLowerCase() === 'all' ? 'ALL' : mgntGrpId;

    const response = await dailySaleApi.get(
      `${LABOUR_CUSTOMIZE.GET_CORP_AND_PC_LIST}?MgntGrpId=${encodeURIComponent(formattedGrpId)}`
    );

    let rawList = [];
    if (Array.isArray(response.data)) {
      rawList = response.data;
    } else if (response.data && typeof response.data === 'object') {
      if (Array.isArray(response.data.data)) rawList = response.data.data;
      else if (Array.isArray(response.data.Data)) rawList = response.data.Data;
      else if (Array.isArray(response.data.result)) rawList = response.data.result;
      else if (Array.isArray(response.data.Result)) rawList = response.data.Result;
    }

    const formattedList = rawList.map((item) => {
      const CorporationID = String(item.CorporationID || '');
      const PCID = item.PCID ?? null;
      const CorporationName = String(item.CorporationName || '');
      const PCName = String(item.PCName || '');
      const PropertyType = String(item.PropertyType || '');
      const Service = String(item.Service || '');
      const Brand = String(item.Brand || '');
      const PMS = String(item.PMS || '');

      // Unique Row ID is composed of CorporationID + CorporationName + PCName + PCID
      const pcidPart = PCID ? String(PCID) : '';
      const id = `${CorporationID}_${CorporationName}_${PCName}_${pcidPart}`;

      return {
        id,
        CorporationID,
        PCID,
        CorporationName,
        PCName,
        PropertyType,
        Service,
        Brand,
        PMS,
        // Compatibility aliases
        dbaName: CorporationName,
        legalName: PCName,
        brandType: PropertyType,
        service: Service,
        brand: Brand,
        pms: PMS,
      };
    });

    return formattedList;
  } catch (error) {
    console.error(`Error fetching corporations for mgntGrpId ${mgntGrpId}:`, error);
    return [];
  }
};

export const getCorpAndPCListByMgntGrpWithPmsBrandSerTypes = getCorpAndPCListByMgntGrp;


export const GetTimeAndAttendanceReport = async (payload) => {
  const res = await laborApi.post(PAYROLL_REPORT.TimeandAttendanceReport, payload);
  return res.data;
}

export const GetMemorizedTimeAndAttendanceReport = async (menuId) => {
  let finalMenuId = menuId;
  if (typeof menuId === 'object' && menuId !== null) {
    finalMenuId = menuId.MenuId || menuId.menuId;
  }
  if (!finalMenuId) {
    finalMenuId = getMenuIdFromUrl() || '000000000000000000000000000000000000';
  }
  const payload = { MenuId: String(finalMenuId) };
  const res = await laborApi.post(PAYROLL_REPORT.GetMemorizedTimeAndAttendanceReport, payload);
  return res.data;
};

export const SaveMemorizedTimeAndAttendanceReport = async (payload) => {
  const res = await laborApi.post(PAYROLL_REPORT.SaveMemorizedTimeAndAttendanceReport, payload);
  return res.data;
};

export const ResetMemorizedTimeAndAttendanceReport = async (payload) => {
  let finalPayload = payload;
  if (typeof payload === 'string') {
    finalPayload = { MenuId: payload };
  } else if (!payload || !payload.MenuId) {
    const finalMenuId =
      (payload && (payload.MenuId || payload.menuId)) ||
      getMenuIdFromUrl() ||
      '000000000000000000000000000000000000';
    finalPayload = { MenuId: String(finalMenuId) };
  }
  const res = await laborApi.post(PAYROLL_REPORT.ResetMemorizedTimeAndAttendanceReport, finalPayload);
  return res.data;
};